<template>
  <div class="flex w-full justify-center items-center">
    <youtube :video-id="videoId" :player-width="playerWidth" :player-height="playerHeight" class="mt-4"></youtube>
  </div>

</template>

<script>
  import Vue from 'vue';
  import VueYouTubeEmbed from 'vue-youtube-embed';
  Vue.use(VueYouTubeEmbed);

  export default {
    name: "Learn",
    data() {
      return {
        sliderIndex: 0
      }
    },
    computed: {
      windowWidth() {
        return this.$store.state.windowWidth;
      },
      playerWidth() {
        if (this.windowWidth < 640) {
          return this.windowWidth * 0.9;
        } else {
          return 640;
        }
      },
      playerHeight() {
        if (this.windowWidth < 640) {
          return this.windowWidth * 0.9 * 0.75;
        } else {
          return 360;
        }
      },
      videoId() {
        return this.$youtube.getIdFromURL('https://www.youtube.com/watch?v=6M3GiKWvt0w');
      }
    }
  }
</script>

<style scoped>

</style>
